import React, { forwardRef } from 'react';
import { Formik, Form as FormBase, FormikConfig } from 'formik';
import { formikfy } from './formikfy';
import { Select as SelectBase, InputLabel } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { KeyboardDatePicker } from '@material-ui/pickers';
import dayjs from 'dayjs';

export const Form: React.FC<FormikConfig<any> & { id?; className?: string }> =
  forwardRef<any, FormikConfig<any>>((props: any, ref: any) => {
    const { children, className, id, ...rest } = props;
    return (
      <Formik {...(rest as any)} ref={ref}>
        {() => (
          <FormBase className={className} id={id}>
            {children}
          </FormBase>
        )}
      </Formik>
    );
  });

const Select = (props) => {
  const { name } = props;
  return (
    <div>
      <InputLabel id={`id-${name}`}>{props.label}</InputLabel>
      <SelectBase labelId={`id-${name}`} {...props} />
    </div>
  );
};

const DateInput = (props) => {
  const { value, variant, error, onChange, form, ...rest } = props;
  return (
    <KeyboardDatePicker
      value={value}
      format="YYYY-MM-DD"
      error={Boolean(error)}
      helperText={error}
      inputVariant={variant}
      onChange={(e) =>
        form.setFieldValue(props.name, dayjs(e).format('YYYY-MM-DD'))
      }
      {...rest}
    />
  );
};

const DateInput_ = (props) => {
  const { value, variant, error, onChange, form, ...rest } = props;
  return (
    <KeyboardDatePicker
      value={new Date(value)}
      format="YYYY-MM-DD"
      variant="inline"
      error={Boolean(error)}
      helperText={error}
      inputVariant={variant}
      {...rest}
    />
  );
};

export const FormDate = formikfy(DateInput, { form: true });
export const FormDateAssignment = formikfy(DateInput_, { form: true });
export const FormSelect = formikfy(Select);
export const FormInput: typeof TextField = formikfy(TextField);
